var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnBtnFlagPl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ICN_BTN_Flag_PL") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "flag-mask",
    width: 18,
    height: 12
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5,8)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#flag-mask"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    href: "#flag-mask"
  }), /*#__PURE__*/React.createElement("rect", {
    mask: "url(#mask)",
    width: 18,
    height: 6,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    mask: "url(#mask)",
    y: 6,
    width: 18,
    height: 6,
    fill: "#DC143C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnBtnFlagPl);
export default __webpack_public_path__ + "static/media/ICN_BTN_Flag_PL.1dc3bfc73d5f33342299a4ba9e671b5d.svg";
export { ForwardRef as ReactComponent };